export default __webpack_public_path__ + "static/media/vae9.02e156ca.png";